<template>
  <div class="projectlist">
    <headerBar title="农产品溯源中心" homeshow="0"></headerBar>
    <companyBar :store_name="store_name" :logo="store_logo"></companyBar>
    <div class="search-bar">
      <p class="title h-f-c-sb">
        <span @click="(noprofectdata = 0), getlistdata()">我的溯源产品</span>
        <span @click="getlistNoData" style="color: red;margin-left: 0.2rem;">未完善产品</span>
      </p>
      <div class="content h-f-c-sb" v-show="noprofectdata == 0">
        <div class="status">
          状态
          <span style="margin-left: 0.1rem;color: #299E72;display: flex;align-items: center;" @click="typestatus = 1">
            {{ typename }}
            <img src="../../static/images/go.png" alt="" />
          </span>
          <div class="status-list" v-show="typestatus == 1">
            <span class="item" @click="choosetype(0, '审核中')">审核中</span>
            <span class="item" @click="choosetype(1, '审核通过')">审核通过</span>
            <span class="item" @click="choosetype(2, '审核失败')">审核失败</span>
          </div>
        </div>
        <div class="search h-f-c-sb">
          <img src="../../static/images/search.png" alt="" />
          <input type="text" placeholder="请输入搜索内容" v-model="keywords" />
        </div>
        <div class="btn" @click="getlistdata()">搜索</div>
      </div>
    </div>

    <div class="tabbar h-f-c-sb" v-show="noprofectdata != 1">
      <div class="item" :class="sort_id == item.id ? 'active' : ''" v-for="item in type_list" :key="item.id" @click="(sort_id = item.id), getlistdata()">{{ item.name }}</div>
    </div>
    <div class="list">
      <div class="item box710" v-for="item in page_data" :key="item.id">
        <img :src="'/' + item.goods_mainshow" alt="" />
        <div class="good">
          <p class="name">{{ item.goods_name }}</p>
          <p class="date">添加时间：{{ item.create_time }}</p>
          <p class="code" v-if="item.sign && item.apply_states == 1">溯源码：{{ item.sign.sign_number }}</p>
          <div class="opt">
            <span v-if="item.apply_states != 1" @click="deleteGoods(item.id)">删除</span>
            <span v-if="item.apply_states != 1" @click="gotiEdit(item.id, item.sort_id)">修改</span>
            <span v-show="noprofectdata == 0 && apply_states == 1" @click="$router.push('/searchResults?_d=ys&goods_id=' + item.id)">查看</span>
            <span @click="$router.push('/ewmapply?goods_id=' + item.id)" v-show="noprofectdata == 0 && apply_states == 1">申请</span>
            <!-- <span @click="$router.push('/extension?goods_id=' + item.id)" v-show="noprofectdata == 0 && apply_states == 1">推广</span> -->
          </div>
        </div>
      </div>
      <div class="no-data" v-show="page_data.length == 0">-- 暂无数据 --</div>
    </div>

    <div class="kuang" @click="gotoProject" v-show="noprofectdata == 0">
      <div class="bgmask"></div>
      <p>新增项目</p>
    </div>
  </div>
</template>

<script>
import { Toast, MessageBox } from 'mint-ui';
export default {
  data() {
    return {
      noprofectdata: 0, //待完善项目
      keywords: '',
      typename: '审核通过',
      typestatus: 0,
      page_data: [],
      type_list: [],
      store_name: '',
      store_logo: '',
      sort_id: 1,
      apply_states: 1 //1审核通过 0审核中 -1审核失败
    };
  },
  created() {},
  mounted() {
    //判断登陆状态,
    if (!window.localStorage.getItem('is_check_login') || window.localStorage.getItem('is_check_login') == 0) {
      //登陆失败
      this.$router.push('/login');
    } else {
      this.checkShopInfo();
      this.getTypeList();
      this.checkShopStatus();
    }
  },
  methods: {
    searchEcode(id) {
      this.$request.post(
        '/front/User/showqr',
        {
          goods_id: id
        },
        res => {
          console.log(res);
          if (res.status == 1) {
            console.log(res.result.sign_qrcode);
            window.location.href = 'https://yuan.znstny.cn/' + res.result.sign_qrcode;
          }
        }
      );
    },
    checkShopStatus() {
      //判断商家审核状态 进行跳转；
      let url = '/front/Appsto/pstatus';
      this.$request.post(url, {}, res => {
        if (res.status == 1) {
          //status -2 未完善信息  0 审核中 1审核通过 -1 审核失败
          if (res.result.status == 1) {
            this.$router.push('/projectList');
          } else {
            this.$router.push('/shopinformation');
          }
        }
      });
    },
    gotiEdit(id, typeid) {
      this.$router.push('/uploadproject?goods_id=' + id + '&typeid=' + typeid);
    },
    deleteGoods(id) {
      MessageBox.confirm('是否删除？', '提示').then(action => {
        this.$request.post('/front/Goods/goodsdl', { goods_id: id }, res => {
          if (res.status == 1) {
            this.page_data.forEach((item, index) => {
              if (item.id == id) {
                this.page_data.splice(index, 1);
              }
            });
          }
          Toast(res.msg);
        });
      });
    },
    getlistNoData() {
      //查看未完善项目
      this.noprofectdata = 1;
      this.$request.post('/front/Goods/imperlist', {}, res => {
        console.log(res);
        if (res.status == 1) {
          this.page_data = res.result;
        }
      });
    },
    choosetype(type, name) {
      this.apply_states = type;
      this.typename = name;
      this.typestatus = 0;
      this.getlistdata();
    },
    getTypeList() {
      this.$request.post('/front/Sundries/slists', {}, res => {
        console.log(res);
        if (res.status == 1) {
          this.type_list = res.result;
          this.sort_id = res.result[0].id || 1;
          this.getlistdata();
        }
      });
    },

    getlistdata() {
      this.$request.post(
        '/front/Goods/glist',
        {
          sort_id: this.sort_id,
          apply_states: this.apply_states,
          key: this.keywords
        },
        res => {
          console.log(res);
          if (res.status == 1) {
            this.page_data = res.result;
          }
        }
      );
    },
    gotoProject() {
      this.$router.push('/choosetype');
    },
    checkShopInfo() {
      //检查商家信息
      this.$request.post('/front/Store/info',
        {
          // id: window.localStorage.getItem('store_id'),
          // token: window.localStorage.getItem('token')
        },
        res => {
          console.log(res);
          if (res.status == 1) {
            this.store_name = res.result.store_name;
            this.store_logo = res.result.logo;
          }
        }
      );
    }
  }
};
</script>

<style lang="scss" scoped>
.projectlist {
  padding-top: 0.8rem;
  padding-bottom: 1rem;
  .search-bar {
    width: 100%;
    padding: 0.15rem 0.2rem;
    background: #cde5dd;
    .title {
      color: #299e72;
      font-size: 0.28rem;
      font-weight: bold;
    }
    .content {
      margin-top: 0.3rem;
      display: flex;
      align-items: center;
      justify-content: space-between;
      .status {
        width: 2rem;
        color: #000000;
        font-size: 0.26rem;
        display: flex;
        position: relative;
        line-height: 0.5rem;
        img {
          margin-left: 0.1rem;
          width: 0.1rem;
          height: 0.2rem;
          transform: rotate(90deg);
        }
      }
      .status-list {
        width: 1.2rem;
        margin-left: 0.1rem;
        position: absolute;
        top: 100%;
        right: 0.2rem;
        background: white;
        height: auto;
        border: 1px solid #cccccc;
        span {
          display: block;
          width: 1.2rem;
          line-height: 0.5rem;
          border-bottom: 1px solid #cccccc;
        }
      }
      .search {
        width: 4.2rem;
        height: 0.6rem;
        border-radius: 0.3rem;
        background: #ffffff;
        padding: 0 0.2rem;
        img {
          width: 0.3rem;
        }
        input {
          height: 0.6rem;
        }
      }
      .btn {
        color: #299e72;
      }
    }
  }
  .tabbar {
    width: 100%;
    height: 0.9rem;
    background: white;
    padding: 0 0.2rem;
    box-sizing: border-box;
    font-weight: bold;
    .item {
      flex: 1;
      height: 0.9rem;
      display: flex;
      align-items: center;
      justify-content: center;
      border-bottom: 2px solid transparent;
    }
    .active {
      color: #299e72;
      border-color: #299e72;
    }
  }
  .list {
    .item {
      background: #ffffff;
      display: flex;
      align-items: center;
      img {
        display: block;
        width: 2rem;
        height: 2rem;
        border-radius: 10px;
        margin-right: 0.2rem;
      }
      .good {
        width: 4.5rem;
        height: 2rem;
        display: flex;
        flex-direction: column;
        justify-content: space-around;
      }
      .name {
        width: 4rem;
        font-weight: bold;
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
      }
      .date {
        color: #666666;
        font-size: 0.24rem;
      }
      .code {
        font-size: 0.26rem;
        color: #000000;
      }
      .opt {
        span {
          padding: 0.05rem 0.1rem;
          background: #d4ece4;
          color: #299e72;
          border: 1px solid #299e72;
          border-radius: 5px;
          font-size: 0.26rem;
        }
      }
    }
  }
  .kuang {
    position: fixed;
    bottom: 0;
    left: 0;
    width: 100%;
    margin: 0;
    border-color: #299e72;
    .bgmask {
      background: #299e72;
      opacity: 1 !important;
    }
    p {
      color: #ffffff;
      font-size: 0.38rem;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/projectList.vue